module.exports = __webpack_public_path__ + "img/y.ea720ef4.png";